import isAxiosError from './isAxiosError';
import HttpStatusCode from '../constants/HttpStatusCode';

const isAuthorizationError = (error: any): boolean =>
    isAxiosError(error) && error.response?.status === HttpStatusCode.Forbidden;

export default isAuthorizationError;
